import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { NEVER } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { UiProgressModule } from '@cigna/shared/angular/progress-ui';
import { WindowService } from '@cigna/shared/angular/core/window-util';
import { LoggingService } from '@cigna/shared/angular/logging-util';
import { LinkRouterService } from './link-router.service';

@Component({
  selector: 'cigna-public-link-router',
  standalone: true,
  imports: [CommonModule, UiProgressModule],
  template: '<div *cignaWaitToLoad="showSpinner$"></div>',
})
export class SecureLinkRouterComponent implements OnInit {
  showSpinner$ = NEVER;

  constructor(
    private _linkRouter: LinkRouterService,
    private _logger: LoggingService,
    private _router: Router,
    private _window: WindowService,
  ) {}

  ngOnInit() {
    this._linkRouter
      .getSecure()
      .pipe(
        tap((response) => this.navigate(response.data.authnUrl)),
        catchError(() => this.onError()),
      )
      .subscribe();
  }

  private navigate(authnUrl: string) {
    this._logger.info(`Navigate to ${authnUrl}`);
    try {
      // URL constructor throws an error if URL is relative
      new URL(authnUrl);
      this._window.open(authnUrl, '_self');
    } catch {
      this._window.open(authnUrl, '_self');
    }
  }

  private onError() {
    const appId = new URLSearchParams(window.location.search).get('key');
    console.error(`Error fetching authnUrl for appId: ${appId}`);
    this._router.navigateByUrl('/');
    return NEVER;
  }
}
